import React, { useState } from 'react';
import { BURL } from '../../../services/base';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
// Image
import SmallLoader from '../../widgets/SmallLoader';
import useAPI from '../../../hooks/useAPI';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar, TextField } from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const TenantInvoice = () => {
    const [loading, setLoading] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [errorText, setErrorText] = React.useState(null);
    const [tenantInvoices, setTenantInvoices] = React.useState([]);
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [confirmationOpen, setConfirmationOpen] = React.useState(false);
    const [invoiceOpen, setInvoiceOpen] = React.useState(false);
    const [invoiceId, setInvoiceId] = React.useState('');
    const [showToaster, setShowToaster] = React.useState(false);
    const [toasterType, setToasterType] = React.useState('success');
    const [message, setMessage] = useState(null);

    const { POST, DELETEREQ } = useAPI();

    const { tenantRoomId } = useParams();

    const formik = useFormik({
        initialValues: {
            title: '',
            description: '',
            amount: ''
        },
        validationSchema: Yup.object({
            title: Yup.string().required('Title is required'),
            description: Yup.string().required('Description is required'),
            amount: Yup.number().typeError('Amount must be a number').required('Amount is required')
        }),
        onSubmit: async (values, { resetForm }) => {
            setInvoiceItems(e => [...e, values]);
            resetForm();
        }
    });

    const getInvoicesByTenantRoom = React.useCallback(async () => {
        const token = localStorage.getItem('token');
        setLoading(true);
        setErrorText(null);
        const response = await axios.get(`${BURL}admin/invoices/tenantRoom`, {
            params: {
                tenantRoomId
            },
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        setLoading(false);

        if (response?.status) {
            const res = await response.data.data
            setTenantInvoices(res);
        } else {
            setShowToaster(true);
            setToasterType('error');
            setMessage(response?.data?.message || 'An error occurred while fetching invoices, try again please.');
        }
    }, []);

    React.useEffect(() => {
        getInvoicesByTenantRoom();
    }, []);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleConfirmation = (invoiceId) => {
        setConfirmationOpen(true);
        setInvoiceId(invoiceId);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setInvoiceOpen(false);
    };

    const handleClickOpen = () => {
        setShowModal(true);
    };

    const handleToasterClose = () => {
        setShowToaster(false);
    };

    const handleAddItemOpen = (invoiceId) => {
        setInvoiceId(invoiceId);
        setInvoiceOpen(true);
    };

    const handleDeleteInvoice = async () => {
        const token = localStorage.getItem('token');
        setConfirmLoading(true);
        setMessage(null);
        try {
            const url = `admin/invoices`;
            const response = await DELETEREQ(url, { invoiceId });
            setShowToaster(true);
            if (!response.ok) {
                setToasterType('error');
                setMessage(response.message || 'An error occurred while deleting the invoice, try again please.');
            } else {
                setToasterType('success');
                setMessage(response.message);
                getInvoicesByTenantRoom();
            }
        } catch (err) {
            setShowToaster(true);
            setToasterType('error');
            setMessage(err.message || 'An error occurred while deleting the invoice, try again please.');
        } finally {
            setConfirmLoading(false);
            setConfirmationOpen(false);
        }
    };

    const handleDeleteItem = (index) => {
        const newItems = [...invoiceItems];
        newItems.splice(index, 1);
        setInvoiceItems(newItems);
    };

    const handleInvoiceItemSave = async () => {
        setConfirmLoading(true);
        const url = 'admin/invoice-items';
        const token = localStorage.getItem('token');
        const body = { tenantRoomId, invoiceId, details: invoiceItems };
        const response = await POST(url, body, token);
        if (response?.status) {
            const res = await response.data;
            setShowToaster(true);
            setToasterType('success');
            setMessage(res.message || 'Invoice items added successfully');
            setInvoiceItems([]);
            setConfirmLoading(false);
            handleClose();
        } else {
            setShowToaster(true);
            setToasterType('error');
            setMessage(response.message ?? 'An error occurred while adding invoice items, try again please.');
            setConfirmLoading(false);
        }
    }

    return (
        <>
            <div className='w-[100%] bg-white py-8 overflow-x-hidden'>
                {/* Property section */}
                <div className="px-[1.22rem] md:px-4 xl:px-10 bg-white overflow-x-hidden  md:w-[99%] lg:w-[82%] xl:w-[96%] 2xl:w-full">
                    <div className='flex justify-between items-center'>
                        <p className='mb-[3rem] xl:mb-[5rem] font-semibold text-[16px] text-gray-400'>Tenant Invoice</p>
                        <button className='px-4 py-2 hover:text-[#0FA958] hover:font-semibold flex items-center gap-1' onClick={handleClickOpen}> <AddHomeWorkIcon className='text-[#6C6C6C]' /> <p className='flex font-light text-[14px] md:text-[16px] items-center py-auto mt-2'>Add Invoice</p>
                        </button>
                    </div>
                    {loading && <SmallLoader />}
                    {(errorText && !loading) && errorText}
                    {!errorText && !loading && !tenantInvoices.length && <div className='mt-24 flex gap-5 lg:mx-0 justify-center text-center'>{(!errorText && !loading && !tenantInvoices.length)
                        && 'There is currently no invoice. Click CREATE invoice to add invoice to a tenant.'}
                    </div>}
                    {errorText && <Button onClick={getInvoicesByTenantRoom}>Try again</Button>}
                    {!loading && tenantInvoices.length != 0 &&
                        <div className='overflow-x-auto my-table w-[100%]'>
                            <table className='table-auto w-full text-[#6C6C6C]'>
                                <thead>
                                    <th>Invoice Type</th>
                                    <th>Title</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    {tenantInvoices.map((invoice, index) =>
                                        <tr className='mb-[30rem] mt-20 border-b-8 border-white'>
                                            <td className='capitalize text-[16px]'>{invoice?.invoiceableType}</td>
                                            <td className='capitalize text-[16px]'>{invoice?.title}</td>
                                            <td className='flex gap-4 items-center'>
                                                <Link to={`/dashboard/tenant/${tenantRoomId}/invoice/${invoice?.title}`}>
                                                    <span title='View invoice item' className='cursor-pointer'>
                                                        <RemoveRedEyeOutlined className='cursor-pointer' />
                                                    </span>
                                                </Link>
                                                <span title='Add invoice item' className='cursor-pointer'>
                                                    <AddIcon className='cursor-pointer' title="Add invoice item" onClick={() => handleAddItemOpen(invoice.id)} />
                                                </span>
                                                <span title='Delete invoice' className='cursor-pointer'>
                                                    <DeleteIcon className='flex items-center cursor-pointer text-[#6C6C6C]' sx={{ fontSize: '18px' }} onClick={() => handleConfirmation(invoice?.id)} />
                                                </span>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
                {/* Invoice Item Modal */}
                <Dialog open={invoiceOpen} onClose={handleClose}>
                    <DialogTitle>Create Invoice Item</DialogTitle>
                    <DialogContent className='overflow-x-hidden w-[100%]'>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="pt-5 items-center w-100 flex flex-col md:flex-row gap-3">
                                <TextField fullWidth id="standard-basic" label="Title" type='text' variant="outlined" name='title' value={formik.values.title} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.title && Boolean(formik.errors.title)} helperText={formik.touched.title && formik.errors.title} />
                                <TextField fullWidth id="standard-basic" label="Description" type='text' variant="outlined" name='description' value={formik.values.description} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.description && Boolean(formik.errors.description)} helperText={formik.touched.description && formik.errors.description} />
                                <TextField fullWidth id="standard-basic" label="Amount" type='text' variant="outlined" name="amount" value={formik.values.amount} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.amount && Boolean(formik.errors.amount)} helperText={formik.touched.amount && formik.errors.amount} />
                            </div>
                            <div className="flex justify-end mt-3">
                                <button type='submit' className='px-4 py-2 border hover:bg-austel-green bg-green-700 text-white flex items-center gap-2'><p className='font-light text-[16px]'>Add Item</p>
                                </button>
                            </div>
                        </form>
                        <div className='overflow-x-auto'>
                            {
                                invoiceItems.length > 0 ? (
                                    <table className="table table-auto w-full mt-10 overflow-x-auto">
                                        <thead>
                                            <tr className='text-left bg-gray-200'>
                                                <th className='py-3 px-5'>S/N</th>
                                                <th>Title</th>
                                                <th>Description</th>
                                                <th>Amount</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                invoiceItems.map((item, i) => {
                                                    return (
                                                        <tr className={`${i % 2 !== 0 && 'bg-gray-100'} border-b text-[16px]`}>
                                                            <td className='py-3 px-5'>{i + 1}</td>
                                                            <td>{item.title}</td>
                                                            <td>{item.description}</td>
                                                            <td>{item.amount}</td>
                                                            <td className='flex gap-4 items-center'>
                                                                {/* <EditIcon className='cursor-pointer' title="Add invoice item" /> */}
                                                                <DeleteIcon className='flex items-center cursor-pointer text-[#6C6C6C]' sx={{ fontSize: '18px' }} onClick={() => handleDeleteItem(i)} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                ) : <div className="pb-5 flex items-center justify-center border-dashed border-green-500 border text-green-500 mt-10 flex-col hover:cursor-pointer bg-white text-[18px]">
                                    <span className='mt-4'>No item added</span>
                                </div>
                            }
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        {confirmLoading ? (
                            <Button disabled><SmallLoader /></Button>
                        ) : (
                            <Button onClick={handleInvoiceItemSave}>Save</Button>
                        )}
                    </DialogActions>
                </Dialog>
                {/* Delete Invoice Item Confirmation Dialog */}
                <Dialog
                    open={confirmationOpen}
                    onClose={() => setConfirmationOpen(false)}
                >
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this invoice item?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmationOpen(false)}>Cancel</Button>
                        {confirmLoading ? (
                            <Button disabled><SmallLoader /></Button>
                        ) : (
                            <Button onClick={handleDeleteInvoice}>Delete</Button>
                        )}
                    </DialogActions>
                </Dialog>
                {/* Snackbar */}
                <Snackbar open={showToaster} autoHideDuration={6000} onClose={handleToasterClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                    <Alert
                        onClose={handleToasterClose}
                        severity={toasterType}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
            </div>
        </>
    )
}

export default TenantInvoice
